module.exports = __webpack_public_path__ + "static/can_i_help.a1686269.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/can_i_help.png
// module id = 436
// module chunks = 35783957827783